import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App/App';
import { AuthProvider } from './context/AuthProvider';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/700.css';
import './index.css';
import {
    ModuleRegistry,
    ClientSideRowModelModule,
    RowDragModule,
    RowApiModule,
    CellStyleModule,
    RowStyleModule,
} from 'ag-grid-community';

ModuleRegistry.registerModules([
    ClientSideRowModelModule,
    RowDragModule,
    RowApiModule,
    CellStyleModule,
    RowStyleModule,
]);

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <BrowserRouter basename={process.env.REACT_APP_BASE_PATH}>
            <AuthProvider>
                <Routes>
                    <Route path="*" element={<App />} />
                </Routes>
            </AuthProvider>
        </BrowserRouter>
    </React.StrictMode>
);
